const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/calibration/devices/$deviceId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/calibration/devices/$deviceId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});